import { Badge, Box, IconButton, Stack, Tooltip, Typography, useMediaQuery } from '@mui/material'
import CustomPopup from 'common/components/CustomPopup'
import UserImage from 'common/components/UserImage'
import { CustomThemeContext } from 'common/providers/CustomThemeProvider'
import AvisosNotifications from 'features/avisos/components/AvisosNotifications'
import { AvisosContext } from 'features/avisos/providers/AvisosProvider'
import Buscador from 'features/buscador/components/Buscador'
import HeaderLaboralNotifications from 'features/documentos/components/HeaderLaboralNotification'
import { DocumentNotificationContext } from 'features/documentos/providers/DocumentNotificationsProvider'
import HeaderNotifications from 'features/notifications/components/HeaderNotifications'
import { NotificationsContext } from 'features/notifications/providers/NotificationsProvider'
import { selectPortal } from 'features/portal/portalSlice'
import PermisosSelector from 'features/users/components/PermisosSelector'
import {
  selectPermisoActual,
  selectPermisos,
  selectPermitirSeleccionarSubempresa,
} from 'features/users/stores/userSlice'
import { Icon } from 'icons/Icons'
import i18n from 'lang/idiomas'
import { enqueueSnackbar } from 'notistack'
import { useContext, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import ThemeManager from 'theming/ThemeManager'

const ANCHOR_TYPES = {
  Notifications: 'Notifications',
  LaboralNotifications: 'LaboralNotifications',
  Avisos: 'Avisos',
  Permisos: 'Permisos',
}

const HeaderActions = () => {
  const { themeController } = useContext(CustomThemeContext)
  const [mostrarAvisosNotificaciones, setMostrarAvisosNotificaciones] = useState(true)
  const [notificationsAnchor, setNotificationsAnchor] = useState(null)
  const [laboralNotificationsAnchor, setlaboralNotificationsAnchor] = useState(null)
  const [avisosNotificationsAnchor, setAvisosNotificationsAnchor] = useState(null)
  const [permisosAnchor, setPermisosAnchor] = useState(null)
  const { count: notificationsCount } = useContext(NotificationsContext)
  const { count: laboralNotificationsCount } = useContext(DocumentNotificationContext)
  const { count: avisosCount, avisos } = useContext(AvisosContext)
  const permisos = useSelector(selectPermisos)
  const permisoActual = useSelector(selectPermisoActual)
  const portal = useSelector(selectPortal)
  const permitirSeleccionarSubempresa = useSelector(selectPermitirSeleccionarSubempresa)

  function setAnchor(event = null, anchorType) {
    if (!event) {
      setNotificationsAnchor(null)
      setlaboralNotificationsAnchor(null)
      setAvisosNotificationsAnchor(null)
      setPermisosAnchor(null)
      return
    }
    if (anchorType === ANCHOR_TYPES.Notifications) setNotificationsAnchor(event.target)
    if (anchorType === ANCHOR_TYPES.LaboralNotifications)
      setlaboralNotificationsAnchor(event.target)
    if (anchorType === ANCHOR_TYPES.Avisos) setAvisosNotificationsAnchor(event.target)
    if (anchorType === ANCHOR_TYPES.Permisos) setPermisosAnchor(event.target)
  }
  const Theme = new ThemeManager()
  const apply = Theme.options.apply ?? false

  const isGreaterThanSm = useMediaQuery(Theme.mui_theme.breakpoints.up('sm'))

  useEffect(() => {
    if (
      !themeController.hide?.HeaderActions?.notificaciones_avisos &&
      avisos &&
      avisos.length > 0 &&
      mostrarAvisosNotificaciones
    ) {
      for (let i = 0; i < avisos.length; i++) {
        enqueueSnackbar(avisos[i].texto_aviso.replace(/<[^>]*>/g, ''), {
          variant: avisos[i].color || 'info',
        })
      }
      setMostrarAvisosNotificaciones(false)
    }
  }, [avisos])

  const esPortalEmpleado = portal?.portal?.tipo_portal === 'PE'

  return (
    <Stack
      className="header-actions"
      direction="row"
      spacing={1}
      sx={{
        width: '100%',
        justifyContent: {
          xs: 'flex-end',
          md: apply ? 'flex-end' : 'flex-start',
        },
      }}
    >
      {themeController.hide?.HeaderActions?.notificaciones_avisos ? (
        <></>
      ) : (
        esPortalEmpleado &&
        permitirSeleccionarSubempresa &&
        permisos &&
        permisos.length > 1 && (
          <>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
              }}
            >
              {permisoActual && (
                <Typography
                  variant="body2"
                  sx={{
                    display: { xs: 'none', md: 'block' },
                    color: 'text.secondary',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {permisoActual.d_rh_centro}
                  {permisoActual.d_rh_subempresa && ` - ${permisoActual.d_rh_subempresa}`}
                </Typography>
              )}
              <Tooltip title="Seleccionar Empresa">
                <IconButton
                  onClick={(event) => {
                    setAnchor(event, ANCHOR_TYPES.Permisos)
                  }}
                  sx={{
                    p: 1,
                    display: {
                      md: 'flex',
                    },
                    color: { xs: 'background.alternativeContrastText', md: 'initial' },
                  }}
                  aria-label="seleccionar empresa"
                  size="large"
                >
                  <Icon
                    icon="fi-rr-building"
                    className="empresas-"
                    sx={{ color: 'secondary.main !important' }}
                  />
                </IconButton>
              </Tooltip>
            </Box>
            <CustomPopup
              anchorEl={permisosAnchor}
              triggerClose={() => setAnchor(null)}
              Child={PermisosSelector}
              childProps={{ onClose: () => setAnchor(null) }}
              anchorOrigin={{ vertical: 'bottom', horizontal: isGreaterThanSm ? 'left' : 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: isGreaterThanSm ? 'left' : 'right' }}
              className="permisosSelectionBox"
            />
          </>
        )
      )}
      {themeController.hide?.HeaderActions?.notificaciones_avisos ? (
        <></>
      ) : (
        <>
          <Tooltip title={i18n.t('eparciales.epavisos', { defaultValue: 'Avisos' })}>
            <IconButton
              onClick={(event) => {
                setAnchor(event, ANCHOR_TYPES.Avisos)
              }}
              sx={{
                p: 1,
                display: {
                  md: 'flex',
                },
                color: { xs: 'background.alternativeContrastText', md: 'initial' },
              }}
              aria-label="delete"
              size="large"
            >
              <Badge badgeContent={avisosCount} color={apply ? 'accent' : 'secondary'}>
                <Icon
                  icon="WarningRounded"
                  className="avisos-"
                  sx={{ color: 'secondary.main !important' }}
                />
              </Badge>
            </IconButton>
          </Tooltip>
          <CustomPopup
            anchorEl={avisosNotificationsAnchor}
            triggerClose={() => setAnchor(null)}
            Child={AvisosNotifications}
            anchorOrigin={{ vertical: 'bottom', horizontal: isGreaterThanSm ? 'left' : 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: isGreaterThanSm ? 'left' : 'right' }}
            className="avisosNotificationBox"
          />
        </>
      )}
      {themeController.hide?.HeaderActions?.notificaciones_generales ? (
        <></>
      ) : (
        <>
          <Tooltip title={i18n.t('notifica', { defaultValue: 'Notificaciones' })}>
            <IconButton
              onClick={(event) => {
                setAnchor(event, ANCHOR_TYPES.Notifications)
              }}
              sx={{
                p: 1,
                display: {
                  md: 'flex',
                },
                color: { xs: 'background.alternativeContrastText', md: 'initial' },
              }}
              aria-label="delete"
              size="large"
            >
              <Badge badgeContent={notificationsCount} color={apply ? 'accent' : 'secondary'}>
                <Icon
                  icon="NotificationsOutlined"
                  className="notifications-"
                  sx={{ color: 'secondary.main !important' }}
                />
              </Badge>
            </IconButton>
          </Tooltip>
          <CustomPopup
            anchorEl={notificationsAnchor}
            triggerClose={() => setAnchor(null)}
            Child={HeaderNotifications}
            anchorOrigin={{ vertical: 'bottom', horizontal: isGreaterThanSm ? 'left' : 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: isGreaterThanSm ? 'left' : 'right' }}
            className="headerNotificationBox"
          />
        </>
      )}
      {themeController.hide?.HeaderActions?.notificaciones_laboral ? (
        <></>
      ) : (
        <>
          <Tooltip title={i18n.t('notiflab', { defaultValue: 'Notificaciones Laborales' })}>
            <IconButton
              onClick={(event) => {
                setAnchor(event, ANCHOR_TYPES.LaboralNotifications)
              }}
              sx={{
                display: {
                  md: 'flex',
                },
                color: { xs: 'background.alternativeContrastText', sm: 'initial' },
              }}
              aria-label="delete"
              size="large"
            >
              <Badge
                badgeContent={laboralNotificationsCount}
                color={apply ? 'accent' : 'secondary'}
              >
                <Icon icon="Memo" />
              </Badge>
            </IconButton>
          </Tooltip>
          <CustomPopup
            anchorEl={laboralNotificationsAnchor}
            triggerClose={() => setAnchor(null)}
            Child={HeaderLaboralNotifications}
            anchorOrigin={{ vertical: 'bottom', horizontal: isGreaterThanSm ? 'left' : 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: isGreaterThanSm ? 'left' : 'right' }}
            className="headerLaboralNotificationBox"
          />
        </>
      )}
      {themeController.hide?.HeaderActions?.buscador ? <></> : <Buscador />}
      <UserImage
        boxSx={{ display: { xs: 'initial', md: 'none', width: '60px' } }}
        hideText={true}
      />
    </Stack>
  )
}

export default HeaderActions
